const billingEN = {
	title: "Billing & Subscription",
	loading: "Loading...",
	errorLoading: "Unable to load billing details right now.",

	currentSubscription: "Current Subscription",
	noSubscription: "No subscription found.",
	startSubscription: "Start subscription",

	pricePerInterval: "{currency} {amount} / {interval}",
	nextBillingOn: "Next billing: {date}",
	status: "Status",
	billingInterval: "Every {frequency} {interval}(s)",

	buttons: {
		updatePaymentMethod: "Update payment method",
		cancelSubscription: "Cancel subscription",
		manageSubscription: "Manage subscription",
	},

	paymentMethod: {
		title: "Payment Method",
		noStored: "No payment method stored yet.",
		brand: "Brand",
		last4: "Last 4",
		expires: "Expires",
	},

	billingInfo: {
		title: "Billing Info",
		started: "Started",
		firstBilled: "First billed",
		nextBilling: "Next billing",
		interval: "Interval",
	},

	upcomingPayment: {
		title: "Upcoming Payment",
		date: "Date",
		subtotal: "Subtotal",
		discount: "Referral Discount",
		totalDue: "Total Due",
	},

	transactions: {
		title: "Transaction History",
		date: "Date",
		invoice: "Invoice",
		subtotal: "Subtotal",
		discount: "Discount",
		total: "Total",
		status: "Status",
		noInvoice: "—",
	},

	referralCredits: {
		title: "Referral Credits",
		availableCredit: "available credit",
		creditBalance: "Credit Balance",
		rewardsEarned: "Rewards earned",
		referral: "referral",
		referrals: "referrals",
		usedCode: "Used Code",
		code: "Code",
		status: "Status",
		shopsReferred: "Shops You Referred",
		rewarded: "Rewarded",
		statusLabels: {
			pending_billing: "Awaiting first payment",
			pending_referrer_payment: "Awaiting referrer's first payment",
			reward_issued: "Discount applied ✓",
		},
	},

	discount: {
		active: "🎉 Referral discount active",
		appliedRange: "Applied {from} → {to}",
	},

	plans: {
		title: "Available Plans",
		options: "{count} options",
		choosePlan: "Choose plan",
	},

	seats: {
		activeSeats: "{count} seat(s) active",
		seatPricing: "{currency} {amount} per seat / month",
		total: "Total billed: {currency} {total}",
	},

	statusBadge: {
		active: "Active",
		canceled: "Canceled",
		paused: "Paused",
		trialing: "Trialing",
		past_due: "Past due",
		unpaid: "Unpaid",
		incomplete: "Incomplete",
		incomplete_expired: "Expired",
		completed: "Completed",
		paid: "Paid",
		pending: "Pending",
	},

	referral: {
		title: "Referral Program",
		loading: "Loading...",
		noCode: "You do not have a referral code yet.",
		generate: "Generate Referral Code",
		codeLabel: "Your Code:",
		copyCode: "Copy Code",
		copyLink: "Copy",
		copied: "Copied to clipboard",
		linkCopied: "Link copied!",
		linkLabel: "Referral Link",
		historyTitle: "Referral History",
		noReferrals: "No referrals yet.",
		defaultShopName: "New Shop",
		applyTitle: "Referral Code",
		applyPlaceholder: "Enter referral code",
		applyButton: "Apply",
		applyLoading: "...",
		usingCode: "Using code:",
		applied: "Referral code applied",
		status: {
			pending: "Pending",
			active: "Active",
			converted: "Converted",
		},
	},

	misc: {
		month: "month",
	},
};

export default billingEN;
